module.exports = __webpack_public_path__ + "static/media/icon3.e89785c1.svg";